import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const PendataanAwalPage = lazy(() => import('./pages/pendataan-awal'))
const PendataanAwalPetugasPage = lazy(() => import('./pages/pendataan-awal-petugas'))
const PindahMaterialPage = lazy(() => import('./pages/pindah-material'))
const PindahMaterialPetugasPage = lazy(() => import('./pages/pindah-material-petugas'))

/** Cluster C15 Warehouse Setup (TAT) — TAT-01 sesi & persetujuan, TAT-02 petugas, TAT-03 daftar & penugasan, TAT-04 petugas pindah. */
const warehouseSetupTatRoutes: RouteObject[] = [
  {
    path: 'warehouse-setup-tat',
    children: [
      { path: 'pendataan-awal', element: <PendataanAwalPage /> },
      { path: 'pendataan-awal-petugas', element: <PendataanAwalPetugasPage /> },
      { path: 'pindah-material', element: <PindahMaterialPage /> },
      { path: 'pindah-material-petugas', element: <PindahMaterialPetugasPage /> }
    ]
  }
]

export default warehouseSetupTatRoutes
